import {
  CREATE_INTERVIEW,
  DELETE_INTERVIEW,
  DEVELOPER_LITS,
  INTERVIEW_LIST,
  SCHEDULE_LIST,
  UPDATE_INTERVIEW,
  UPDATE_INTERVIEW_STATUS,
  VIEW_INTERVIEW,
} from "./apiRoutes";
import { authData } from "./Service";

export const createInterviewApi = async (data) => {
  const response = await authData.post(CREATE_INTERVIEW, data);
  return response?.data;
};
export const listOfInterviewApi = async (data) => {
  const response = await authData.post(INTERVIEW_LIST, data);
  return response?.data;
};

export const viewInterview = async (id) => {
  const response = await authData.get(`${VIEW_INTERVIEW}${id}`);
  return response?.data;
};
export const updateInterviewStatusApi = async (data) => {
  const response = await authData.put(UPDATE_INTERVIEW_STATUS, data);
  return response?.data;
};
export const listOfSchedulerwApi = async (data) => {
  const response = await authData.post(SCHEDULE_LIST, data);
  return response?.data;
};
export const listOfDeveloperApi = async (data) => {
  const response = await authData.post(DEVELOPER_LITS, data);
  return response?.data;
};
export const deleteInterviewApi = async (id) => {
  const response = await authData.get(`${DELETE_INTERVIEW}${id}`);
  return response?.data;
};
export const updateInterviewApi = async (data) => {
  const response = await authData.put(UPDATE_INTERVIEW, data);
  return response?.data;
};
